import { render } from "./마이페이지_팝업.vue?vue&type=template&id=8815eb56"
import script from "./마이페이지_팝업.vue?vue&type=script&lang=js"
export * from "./마이페이지_팝업.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__